import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

//https://stackoverflow.com/questions/64173738/change-react-material-ui-datagrid-table-default-font-size
const modelColumns: GridColDef[] = [
    { field: 'model', headerName: 'CTE View', flex: 1 },
    { field: 'type', headerName: 'Component Type', flex: 1 },
    { field: 'name', headerName: 'Component Name', flex: 1 },
    { field: 'infield_count', headerName: 'Incoming Field Count', flex: 0.5, type: 'number' },
    { field: 'merge_size', headerName: 'Merge Size', flex: 0.5, type: 'number' },
    { field: 'outfield_count', headerName: 'Outgoing Field Count', flex: 0.5, type: 'number' },
    { field: 'fork_size', headerName: 'Fork Size', flex: 0.5, type: 'number' },
    { field: 'lookup_count', headerName: 'Lookup Expression Count', flex: 0.5, type: 'number' },
    { field: 'avg_complexity', headerName: 'Complexity', flex: 0.5, type: 'number' },
    { field: 'qname', headerName: 'ID', width: 3.5 }
];
const mappletColumns: GridColDef[] = [
    { field: 'model', headerName: 'Mapplet', flex: 1 },
    { field: 'type', headerName: 'Component Type', flex: 1 },
    { field: 'name', headerName: 'Component Name', flex: 1 },
    { field: 'infield_count', headerName: 'Incoming Field Count', flex: 0.5, type: 'number' },
    { field: 'merge_size', headerName: 'Merge Size', flex: 0.5, type: 'number' },
    { field: 'outfield_count', headerName: 'Outgoing Field Count', flex: 0.5, type: 'number' },
    { field: 'fork_size', headerName: 'Fork Size', flex: 0.5, type: 'number' },
    { field: 'lookup_count', headerName: 'Lookup Expression Count', flex: 0.5, type: 'number' },
    { field: 'avg_complexity', headerName: 'Complexity', flex: 0.5, type: 'number' },
    { field: 'qname', headerName: 'ID', width: 3.5 }
];

const intialColumnVisibility = { columns: { columnVisibilityModel: { qname: false} } };

const ShowStats = (props) => {
    function GetSortOrder(prop1) {
        return function (a, b) {
            if (a[prop1] > b[prop1]) {
                return 1;
            } else if (a[prop1] < b[prop1]) {
                return -1;
            }
            return 0
        }
    }

    const { sequenceSqlList, cteSqlList, targetSqlList, stats } = { ...props.data };
    const rows = stats;
    const total_size = sequenceSqlList.length + cteSqlList.length + targetSqlList.length;
    const seqMsg = sequenceSqlList ? sequenceSqlList.length + " sequence(s)" : "";
    const cteMsg = cteSqlList ? cteSqlList.length + " CTE(s)" : "";
    const tgtMsg = targetSqlList ? targetSqlList.length + " DML Target(s)" : "";
    const fullMsgTmp = seqMsg + seqMsg.length > 0 ? " and " : "" + cteMsg + " and " + tgtMsg;
    const fullMsg = total_size > 0 ? "The generated code includes "+fullMsgTmp+"." : "";
    const result =
        rows.slice()
        //.filter(e => e.avg_complexity > 0)
            .map((current, id) => current = { ...current, id });
    const mappletNames = new Set(result.slice().filter(e => e.type === "Mapplet").map(e => e.model));
    const mapplets = result.slice().filter(e => mappletNames.has(e.model)).filter(e => e.avg_complexity > 0);
    const models = result.slice().filter(e => !mappletNames.has(e.model)).filter(e => e.avg_complexity > 0);

    /*
        [...new Set(rows.slice().map(JSON.stringify))]
            .sort()
            .map(JSON.parse)
            .map((current, id) => current = { ...current, id }); //index instead of id => getRowId={row => row.index}
            */
    const total_complexity = mapplets.reduce((accumulator, current) => accumulator + current.avg_complexity, 0)
                                    +
                             models.reduce((accumulator, current) => accumulator + current.avg_complexity, 0);
    const hours_required = Math.floor(total_complexity / 60) > 0 ? Math.floor(total_complexity / 60) + ' hours' : '';
    const minutes_required = total_complexity % 60 > 0 ? total_complexity % 60 + ' minutes' : '';
    const savings_message = hours_required.length > 0 && minutes_required.length > 0 ? hours_required + ' and ' + minutes_required
        : hours_required.length > 0 ? hours_required : minutes_required;
    //console.log(rows);

    return (
        <div>
            <div style={{ fontSize: 14, fontColor: 'blue' }}>
                <Box sx={{ height: 40, width: '100%', color: "primary.main", backgroundColor: "lightblue", border: '1px solid lightblue', }}>
                    <Box sx={{ color: 'black', height: 50 }}>
                        <Typography variant="caption" display="block" gutterBottom>The converter saved you {savings_message} in translating your workflow into SQL equivalent.<br />{fullMsg}</Typography>
                    </Box>
                </Box>
            </div>
            <Typography variant="caption" display="block" gutterBottom></Typography>
            <div style={{ fontSize: 14, fontColor: 'blue' }}>
                <Box sx={{ height: 150, width: '100%', color: "primary.main", backgroundColor: "lightgreen", border: '1px solid lightblue', }}>
                    <Box sx={{ height: 150, }}>
                        {/*<Divider>Models</Divider> */}
                        <DataGrid initialState={intialColumnVisibility} rowHeight={14} rows={models} columns={modelColumns} pageSize={15} rowsPerPageOptions={[15]} sx={{ border: 'none', fontSize: 10, }} />
                    </Box>
                </Box>
            </div>
            <Typography variant="caption" display="block" gutterBottom></Typography>
            <div style={{ fontSize: 14, fontColor: 'blue' }}>
                <Box sx={{ height: 150, width: '100%', color: "primary.main", backgroundColor: "lightgrey", border: '1px solid lightblue', }}>
                    <Box sx={{ height: 150, }}>
                        {/*<Divider>Mapplets</Divider>*/}
                        <DataGrid aria-labelledby="Mapplet" initialState={intialColumnVisibility} rowHeight={14} rows={mapplets} columns={mappletColumns} pageSize={15} rowsPerPageOptions={[15]} sx={{ border: 'none', fontSize: 10, }} />
                    </Box>
                </Box>
            </div>
        </div>
    );
};

export default ShowStats;